// src/components/ProtectedRoute.js
import { Navigate } from "react-router-dom";

// Token utility functions
const isTokenExpired = (token) => {
  try {
    if (!token) return true;
    const payload = token.split('.')[1];
    if (!payload) return true;
    const decoded = JSON.parse(atob(payload));
    if (!decoded.exp) return true;
    // exp is in seconds, Date.now() is in milliseconds
    return decoded.exp * 1000 < Date.now();
  } catch (err) {
    return true;
  }
};

const getTokenExpiryTime = (token) => {
  try {
    if (!token) return 0;
    const payload = token.split('.')[1];
    if (!payload) return 0;
    const decoded = JSON.parse(atob(payload));
    return decoded.exp ? decoded.exp * 1000 : 0;
  } catch (err) {
    return 0;
  }
};

// ProtectedRoute component to check authentication & role
const ProtectedRoute = ({ children, allowedRoles }) => {
  const authToken = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  const userRole = localStorage.getItem("role");
  const userId = localStorage.getItem("userId");

  // Check if token exists and is not expired
  const tokenValid = authToken && !isTokenExpired(authToken);

  // If token is expired but we have a refresh token, try to refresh
  if (!tokenValid && refreshToken) {
    // We'll let the components handle the refresh
    // For now, check if there's any token at all
    if (!authToken) {
      return <Navigate to="/restaurantAuth" replace />;
    }
    
    // If token is expired, redirect to login
    // The components will handle refresh if possible
    localStorage.removeItem('access_token');
    return <Navigate to="/restaurantAuth" replace />;
  }

  // If user is not logged in, redirect to login page
  if (!authToken || !userId) {
    return <Navigate to="/restaurantAuth" replace />;
  }

  // If token is expired, redirect to login
  if (!tokenValid) {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user_data');
    localStorage.removeItem('role');
    localStorage.removeItem('userId');
    return <Navigate to="/restaurantAuth" replace />;
  }

  // If user's role is not in allowedRoles, redirect to unauthorized page
  if (allowedRoles && allowedRoles.length > 0) {
    if (!allowedRoles.includes(userRole)) {
      // Redirect to appropriate dashboard based on role
      if (userRole === 'manager') {
        return <Navigate to="/ManagerDashboard_A" replace />;
      } else if (userRole === 'waiter') {
        return <Navigate to="/restaurant/african" replace />;
      } else {
        return <Navigate to="/" replace />;
      }
    }
  }

  return children;
};

export default ProtectedRoute;